export default __webpack_public_path__ + "static/tad_cip_2-e58406aef93e66d11f17ed6b365c8ce5.jpeg";